<template>
  <label
    class="input-file-custom"
    :class="{ drag: isDrag }"
    @dragleave="dropEnd"
    @dragend="dropEnd"
    @drop="dropEnd"
    @dragenter="dropStart"
  >
    <input type="file" @change="selectFiles" :multiple="multiple" :accept="accept" ref="input" />
    <slot>
      <button class="primary"><img src="@/assets/icons/plus.svg" alt="" /></button>
      <span class="about">{{ $t('form.input-file.about') }}</span>
    </slot>
    <div class="preview" v-if="preview">
      <img :src="preview" />
    </div>
  </label>
</template>

<script>
export default {
  name: 'InputFile',
  data: () => ({
    isDrag: false,
  }),
  props: {
    value: {},
    file: {},
    multiple: {
      default: true,
    },
    accept: {
      default: false,
    },
    includeReader: {
      default: false,
    },
  },
  computed: {
    preview() {
      if (!this.file) return null
      if (typeof this.file === 'string') {
        return this.file
      }
      try {
        return URL.createObjectURL(this.file)
      } catch (e) {
        return null
      }

    },
  },
  methods: {
    dropStart() {
      this.isDrag = true
    },
    dropEnd() {
      this.isDrag = false
    },
    selectFiles(e) {
      const files = e.target.files
      this.$emit('change', this.multiple ? files : files[0])
    },
  },
  watch: {
    preview(res) {
      this.$emit('onReader', res)
    },
    value() {
      this.$refs.input.value = undefined
    },
  },
}
</script>

<style lang="scss">
.input-file-custom {
  position: relative;
  @include flexCenter;
  flex-direction: column;
  width: 100%;
  height: 108px;
  border: 1px dashed $lightGray;
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.25s;

  &.drag {
    border: 1px dashed rgba($textLight, 1);
    background: rgba($lightGray, 0.75);
  }

  input {
    @include inputHide;
    width: auto;
    height: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
  }

  button {
    margin-bottom: 10px;

    img {
      margin: 0 !important;
    }
  }

  .about {
    font-weight: bold;
    font-size: 14px;
    line-height: 123%;
    color: $dark;
  }
}
</style>

<style lang="scss" scoped>
.preview {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  z-index: 2;
  backface-visibility: hidden;
  transition: opacity 0.25s $ease;

  img {
    flex: 1 1 auto;
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  &:hover {
    opacity: 0.7;
  }
}
</style>
